"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wordLimit = exports.UserStatus = exports.UserRole = exports.StorageKey = exports.SentryErrorsWhitelist = exports.RemoveAdminUserActions = exports.PendingMemberRemoveAdminUserActions = exports.PendingMemberAdminActions = exports.PasswordLength = exports.PRIVACY_POLICY = exports.KeyCodes = exports.DateConversionType = exports.ActiveMemberAdminActions = exports.ActionKey = void 0;
var PasswordLength = exports.PasswordLength = '6';
var UserStatus = exports.UserStatus = {
  REVOKED: 'REVOKED',
  INVALID: 'INVALID',
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING'
};
var UserRole = exports.UserRole = {
  ADMIN: 'ADMIN',
  USER: 'USER'
};
var ActionKey = exports.ActionKey = {
  ADMIN: 'ADMIN',
  USER: 'USER'
};
var StorageKey = exports.StorageKey = {
  ORG_INFO: 'ORG_INFO',
  USER_INFO: 'USER_INFO',
  PRODUCT_ID: 'PRODUCT_ID',
  GOOGLE_ACCESS_TOKEN: 'GOOGLE_ACCESS_TOKEN',
  COGNITO_ACCESS_TOKEN: 'COGNITO_ACCESS_TOKEN',
  REQUESTER_USER_ID: 'REQUESTER_USER_ID',
  SIGN_IN_MODE: 'SIGN_IN_MODE',
  IS_GOOGLED_SIGNED: 'IS_GOOGLED_SIGNED',
  // can we removed later
  USER_ORGS: 'USER_ORGS',
  REDIRECT_URL: 'REDIRECT_URL',
  HTTP_CLIENT_CONFIG: 'HTTP_CLIENT_CONFIG',
  ANONYMOUS_USER_SESSION_ID: 'ANONYMOUS_USER_SESSION_ID',
  REVIEW_LAST_PAGE: 'REVIEW_LAST_PAGE',
  REVIEW_DRAFT_DATA: 'REVIEW_DRAFT_DATA'
};
var ActiveMemberAdminActions = exports.ActiveMemberAdminActions = [{
  text: 'Make Workspace Admin',
  type: 'text',
  id: 'change_role'
}, {
  text: 'Remove User',
  type: 'text',
  id: 'delete_user'
}];
var RemoveAdminUserActions = exports.RemoveAdminUserActions = [{
  text: 'Remove Admin Rights',
  type: 'text',
  id: 'change_role'
}, {
  text: 'Remove User',
  type: 'text',
  id: 'delete_user'
}];
var PendingMemberAdminActions = exports.PendingMemberAdminActions = [{
  text: 'Make Admin',
  type: 'text',
  id: 'change_role'
}, {
  text: 'Reinvite',
  type: 'text',
  id: 'reinvite'
}, {
  text: 'Revoke Invitation',
  type: 'text',
  id: 'revoke_invitation'
}];
var PendingMemberRemoveAdminUserActions = exports.PendingMemberRemoveAdminUserActions = [{
  text: 'Remove Admin Rights',
  type: 'text',
  id: 'change_role'
}, {
  text: 'Reinvite',
  type: 'text',
  id: 'reinvite'
}, {
  text: 'Revoke Invitation',
  type: 'text',
  id: 'revoke_invitation'
}];
var DateConversionType = exports.DateConversionType = {
  HOUR_AND_DATE: 'HOUR_AND_DATE',
  TIME_AGO: 'TIME_AGO',
  DATE_AND_YEAR: 'DATE_AND_YEAR'
};
var wordLimit = exports.wordLimit = {
  ZERO: 'ZERO',
  LOW: 'LOW',
  MEDIUM: 'MEDIUM',
  FULL: 'FULL',
  OVER: 'OVER'
};
var KeyCodes = exports.KeyCodes = {
  escape: 27,
  enter: 13,
  space: 32,
  arrowDown: 40,
  arrowUp: 38
};
var PRIVACY_POLICY = exports.PRIVACY_POLICY = 'https://www.xto10x.com/privacy-policy';
var SentryErrorsWhitelist = exports.SentryErrorsWhitelist = ['Non-Error exception captured', 'Loading chunk', 'ResizeObserver loop limit exceeded', "Identifier 'originalPrompt' has already been declared", 'this.remove is not a function', 'Maximum call stack size exceeded', 'Installations: Could not process request. Application offline', 'Network Error', 'Please check your network connection and try again', "Cannot read property 'contentWindow' of null", "Unable to get property 'ownerDocument' of undefined or null reference", "undefined is not an object (evaluating 'e.groups.includes')", 'SyntaxError: SyntaxError', 'service_worker Rejected', 'User is not authorized to access this resource with an explicit deny'];